var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"height":"100%"}},[(_vm.params.value > 3)?_c('vs-chip',{staticStyle:{"height":"60%","top":"20%"},attrs:{"color":_vm.priorityToColor(_vm.params.value)}},[_vm._v(_vm._s(_vm.params.value))]):_c('p',[_vm._v(_vm._s(_vm.params.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }